import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { MyRouterContext } from '@/App';
import { BeforeLoadContext } from '@tanstack/react-router/dist/esm/route';
import { isAdmin, isPersonalTenant } from '@/lib/auth';

export const Route = createFileRoute('/_main/_project/')({
  beforeLoad,
  component: () => <Outlet />,
});

async function beforeLoad({
  search,
  context,
}: BeforeLoadContext<{ project?: string }, Record<never, string>, MyRouterContext>) {
  // Redirect to the appropriate page based on the user's role
  if (isAdmin(context.userInfo)) {
    throw redirect({ to: '/tenant', search });
  }
  // Freeプランの API キーは個人 API キー 1 本でプロファイル画面にあり、プロジェクトの API キー一覧は使わない
  if (isPersonalTenant(context.userInfo)) {
    throw redirect({ to: '/profile' });
  }
  throw redirect({ to: '/project', search, throw: true });
}
